import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useDeDeleteReferralMutation as useDeDeleteReferralMutationType } from "@/modules/patients/detail/referral/de/services/__generated__/useDeDeleteReferralMutation.graphql"

const deleteReferralMutation = graphql`
  mutation useDeDeleteReferralMutation($input: De_deleteReferralLetterInput!) {
    de_deleteReferralLetter(input: $input) {
      de_ReferralLetter {
        id @deleteRecord
      }
    }
  }
`

const useDeDeleteReferralMutation = () => {
  const [commit, isFlight] = useMutation<useDeDeleteReferralMutationType>(deleteReferralMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeDeleteReferralMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeDeleteReferralMutation }
